import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const UnlockKeyholeIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M7 7a5 5 0 0 1 10 0 1 1 0 1 1-2 0 3 3 0 1 0-6 0v3h9a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-6a3 3 0 0 1 3-3h1V7Zm-1 5a1 1 0 0 0-1 1v6c0 .6.4 1 1 1h12c.6 0 1-.4 1-1v-6c0-.6-.4-1-1-1H6Zm6 2c.6 0 1 .4 1 1v2a1 1 0 1 1-2 0v-2c0-.6.4-1 1-1Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default UnlockKeyholeIcon;
